import {ref} from "vue";
import {auth} from "@/firebase/config";

let errorMessage = ref("");
let signIn = async (email, password)=>{
    try {
        let res = await auth.signInWithEmailAndPassword(email, password);
        // console.log(res.user);
        if (!res){
            throw new Error("Can't Login Account!");
        }
        return res;
    }catch (e) {
        errorMessage.value = e.message;
        console.log(errorMessage.value);
    }
}

let useSignIn = ()=>{
    return { errorMessage, signIn};
}
export default useSignIn;